import React from 'react'
import CardElement from '../../components/card.v2'
import InputElement from '../../components/InputElement'
import TextAreaElement from '../../components/TextArea'
import { useFormikContext } from 'formik'
import SelectElement from '../../components/Select'
import { HoverBorderGradientDemo } from '../../components/Button'

const Bio = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFieldValue(`bio.${name}`, value) // Update userData dynamically
  }

  return (
    <div className='max-w-xl mx-auto'>
      <CardElement className={'w-full'}>
        <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
          <svg
            onClick={() => {
              setCurrentStep(currentStep - 1)
            }}
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='2'
            stroke='currentColor'
            className='w-5 h-5'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M15 19l-7-7 7-7'
            />
          </svg>
        </h2>
        <div className='max-h-[170px] md:max-h-[calc(100vh-400px)] h-auto overflow-auto custom-scrollbar px-6'>
          <div className=''>
            <InputElement
              label='Company Name'
              type='text'
              name='companyName'
              value={values?.bio?.companyName || ''}
              handleInputChange={handleInputChange}
              placeholder='Company Name'
            />

            <InputElement
              label='Address'
              type='text'
              name='address'
              value={values?.bio?.address || ''}
              handleInputChange={handleInputChange}
              placeholder={'address'}
            />

            <div className='my-4'>
              <SelectElement
                label={'Location'}
                placeholder={'Select Location Count'}
                name='locationCount'
                value={values?.bio?.locationCount || ''}
                onChange={handleInputChange}
                options={[
                  { value: 'single', label: 'Single Office' },
                  { value: 'multiple', label: 'Multiple Locations' },
                ]}
              />

              {values?.bio?.locationCount == 'multiple' && (
                <TextAreaElement
                  type='text'
                  name='locationDesc'
                  value={values?.bio?.locationDesc || ''}
                  handleInputChange={handleInputChange}
                  placeholder='Specify below'
                />
              )}
            </div>

            {/* Number of Employees */}
            <div className='my-4'>
              <SelectElement
                label={'Number of Employees'}
                placeholder={'Select employees count'}
                name='employees'
                value={values?.bio?.employees || ''}
                onChange={handleInputChange}
                options={[
                  { value: '1-5', label: '1-5' },
                  { value: '6-15', label: '6-15' },
                  { value: '16-50', label: '16-50' },
                  { value: '50+', label: '50+' },
                ]}
              />
            </div>
          </div>

          <div className=''>
            {/* Practice Areas */}
            <div className='my-4'>
              <SelectElement
                label={'Practice Areas'}
                placeholder={'Select practice areas count'}
                name='practiceArea'
                value={values?.bio?.practiceArea || ''}
                onChange={handleInputChange}
                options={[
                  { value: 'Criminal Law', label: 'Criminal Law' },
                  { value: 'Family Law', label: 'Family Law' },
                  { value: 'Intellectual', label: 'Intellectual' },
                  { value: 'Civil Litigation', label: 'Civil Litigation' },
                  { value: 'Corporate Law', label: 'Corporate Law' },
                  { value: 'Other', label: 'Other' },
                ]}
              />

              {values?.bio?.practiceArea == 'Other' && (
                <TextAreaElement
                  type='text'
                  placeholder='Specify below'
                  name='practiceDesc'
                  value={values?.bio?.practiceDesc || ''}
                  onChange={handleInputChange}
                />
              )}
            </div>

            {/* Primary Client Type */}
            <div className='my-4'>
              <SelectElement
                label={'Primary Client Type'}
                placeholder={'Select client type'}
                name='clientType'
                value={values?.bio?.clientType || ''}
                onChange={handleInputChange}
                options={[
                  { value: 'Individuals', label: 'Individuals' },
                  { value: 'Businesses', label: 'Businesses' },
                  { value: 'Both', label: 'Both' },
                ]}
              />
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className='md:col-span-2 md:flex md:justify-end sticky bottom-0'>
          <div className='mt-8'>
            <HoverBorderGradientDemo
              type='button'
              onClick={() => {
                setCurrentStep(currentStep + 1)
              }}
            >
              <span className='font-bold capitalize px-12'>Next</span>
            </HoverBorderGradientDemo>
          </div>
        </div>
      </CardElement>
    </div>
  )
}

export default Bio
